module.exports = ".invalid-feedback {\n  color: #a94442;\n  margin: 5px; }\n\n.dataTables_wrapper {\n  margin-top: 50px !important; }\n\n.imageCSS {\n  height: 40px;\n  width: 40px;\n  border: 1px solid gray;\n  border-radius: 100%; }\n\ntextarea {\n  resize: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/add-firebase-messages/add-firebase-messages.component.scss
// module id = ./src/app/admin/add-firebase-messages/add-firebase-messages.component.scss
// module chunks = main